import React from 'react';
import PropTypes from 'prop-types';

const UPI = ({ fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.1093 8.92511L9.42684 1.77761C9.36492 1.63037 9.25761 1.50674 9.12053 1.42474C8.98345 1.34274 8.82378 1.30664 8.66476 1.3217C8.50574 1.33677 8.35568 1.40221 8.23644 1.5085C8.1172 1.61478 8.03501 1.75636 8.00184 1.91261L7.49934 3.57011L6.88434 5.74511L7.91934 7.75511L8.53434 5.57261L8.91684 4.20761L11.4443 9.09761L6.19434 13.9726L6.67434 12.2476L7.49934 9.44261L5.30184 11.4376L4.49934 14.2501L3.95184 16.1851C3.90527 16.3449 3.91316 16.5156 3.97426 16.6704C4.03536 16.8252 4.1462 16.9552 4.28934 17.0401C4.43525 17.1394 4.61151 17.1841 4.7871 17.1662C4.9627 17.1484 5.12638 17.0692 5.24934 16.9426L12.9443 9.82511C13.0673 9.71432 13.1501 9.56598 13.18 9.40319C13.2098 9.2404 13.185 9.07231 13.1093 8.92511Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.02 8.41516L8.56501 5.57266L7.50001 3.57016L6.34501 1.26766C6.277 1.13061 6.16869 1.01765 6.03464 0.943913C5.90058 0.870181 5.74718 0.839212 5.59501 0.855161C5.4409 0.866537 5.29407 0.925239 5.17459 1.02324C5.05511 1.12124 4.96882 1.25375 4.92751 1.40266L0.892512 15.6527C0.847087 15.8106 0.854774 15.979 0.914394 16.1321C0.974014 16.2853 1.08227 16.4146 1.22251 16.5002C1.36412 16.5907 1.53204 16.631 1.69933 16.6147C1.86661 16.5984 2.02357 16.5264 2.14501 16.4102L4.50001 14.2502L6.65251 12.2552L9.84751 9.32266C9.97342 9.21234 10.0588 9.06308 10.0901 8.89862C10.1213 8.73417 10.0967 8.56398 10.02 8.41516ZM7.50001 9.44266L5.30251 11.4377L3.11251 13.5002L5.87251 3.75016L6.91501 5.74516L7.95001 7.75516L8.38501 8.60266L7.50001 9.44266Z"
      fill={fill || '#6B6C7B'}
    />
  </svg>
);

UPI.propTypes = {
  fill: PropTypes.string,
};

export default UPI;
